import { Typography } from 'antd';

import styles from '~/app/login/login.module.css';

const { Text } = Typography;

type LoginFooterBarProps = {
  rightsReserved: string;
};

export function LoginFooterBar({ rightsReserved }: LoginFooterBarProps) {
  return (
    <footer className={styles.footerBar}>
      <Text type="secondary">{rightsReserved}</Text>
    </footer>
  );
}
